import { create } from "zustand";

export interface IScrollPosition {
  root: number;
  feed: number | null;
}

export const createDefaultScrollPosition = (): IScrollPosition => ({
  root: 0,
  feed: null,
});

interface IState {
  scrolls: Record<string, IScrollPosition>;
  scrollElement: HTMLElement | null;
  setScroll: (key: string, value: IScrollPosition) => void;
  setScrollElement: (element: HTMLElement | null) => void;
}

export const useScrollStore = create<IState>(
  (set) => ({
    scrolls: {},
    scrollElement: null,
    setScroll: (key, value) => {
      set(({ scrolls }) => ({
        scrolls: {
          ...scrolls,
          [key]: value,
        }
      }));
    },
    setScrollElement: (scrollElement) => set(() => ({ scrollElement }))
  }),
);
